import type { MouseEventHandler, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { START_FREE_URL, START_FREE_EXTERNAL } from '../config/links';

interface StartFreeLinkProps {
  className?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export default function StartFreeLink({ className, children, onClick }: StartFreeLinkProps) {
  // Internal route (e.g. /start-free) → SPA navigation via router Link.
  // Hash (#cta) or external URL → plain anchor.
  const isInternalRoute = START_FREE_URL.startsWith('/');

  if (isInternalRoute) {
    return (
      <Link to={START_FREE_URL} onClick={onClick} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <a
      href={START_FREE_URL}
      onClick={onClick}
      className={className}
      {...(START_FREE_EXTERNAL ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {children}
    </a>
  );
}
